import{Pagination as HeroUIPagination}from"@heroui/react";const Pagination=HeroUIPagination;export default Pagination;